
const labels = {
    'en-US': {
        today: 'Today',
        'current-weather':'CURRENT WEATHER',
        'air-conditioans':'AIR CONDITIONS',
        'humidity':'Humidity',
        'clouds':'Clouds',
        'wind-speed':'Wind',
        'feels-like':'Real Feel',
        'today-hourly':'TODAY\'S FORECAST',
        'coming-days-forecast':'Coming days forecast',
        'log-in':'Log In',
        submitButton: 'Submit',
        cancelButton: 'Cancel',
        // Add more labels as needed
    },
    'zh-CN': {
        today: '今日',
        'current-weather':'实时天气',
        'air-conditioans':'气温',
        'humidity':'湿度',
        'wind-speed':'风速',
        'clouds':'云量',
        'feels-like':'体感温度',
        'today-hourly':'今日分时段预测表',
        'coming-days-forecast':'未来几天预报',
        'log-in':'登录',
        submitButton: '提交',
        cancelButton: '取消',
        // Add more labels as needed
    },
    'zh-Hant': {
        today: '今日',
        'current-weather':'實時天氣',
        'air-conditioans':'氣溫',
        'humidity':'濕度',
        'clouds':'雲量',
        'wind-speed':'風速',
        'feels-like':'體感溫度',
        'today-hourly':'今日分時段預測表',
        'coming-days-forecast':'未來幾天預報',
        'log-in':'登錄',
        submitButton: '提交',
        cancelButton: '取消',
        // Add more labels as needed
    },
    // Add more languages as needed
};

export default labels;